import React, { Component } from 'react';
import { Col, Form, Button } from 'reactstrap';
import TYPE_OF_CARD from 'assets/images/upi_crop.png';
import BHIM_UPI_Image from 'assets/images/bhim.png';
import GPAY_UPI_Image from 'assets/images/google-paya.jpeg';
import PHONEPAY_UPI_Image from 'assets/images/phonepay.jpg';
import PAYTM_UPI_Image from 'assets/images/paytm.png';
import { connect } from 'react-redux';
import { callVPAResponse, callGetTxnStatus } from 'actions/payment';
import { DisplayPayBtnText, RenderForm, GoBack} from 'components/Common';
import UPIModal from "components/FDModal/upi-payment";
import GlobalLoaderModal from "components/FDModal/global-loader";
import GlobalErrorModal from "components/FDModal/global-error";
import FPConfig  from 'lib/config';

class UPI extends Component {
    
    submitUPI = this.submitUPI.bind(this);
    submitVPA = this.submitVPA.bind(this);
    submitVPACallTrack = false;
    closeVpaModal = this.closeVpaModal.bind(this);
    state = { selectedPay: "SC",
     loader: false, 
     canDisplayUPI: false, 
     isCalledTxnStatus: false,
     upiScanComplete:false,
     upiScanSuccess:false 
    
    }

    submitUPI(){
        this.setState({canDisplayUPI: true})
    }

    componentDidMount(){
        if(this.props.integrationType === 'MERCHANT_PAYMENT_MODE_INTEGRATION' && this.props.selectedPayment === 'UPI'){
            this.props.customerDetails.customerVPAId && this.submitVPA(this.props.customerDetails.customerVPAId)
        }
    }

    closeVpaModal(){
        this.setState({canDisplayUPI: false})
    }
    
    async submitVPA(vpaNo){
        if(!this.submitVPACallTrack){
            this.submitVPACallTrack = true;
            this.setState({loader: true})
            //console.log("submitVPA= ", vpaNo)
            // this.setState({error: "Please enter the valid VPA"})
            this.props.callVPAResponse(vpaNo, this.props.txnKey, this.props.txnIv).then((vpa_data)=>{
                let { getTxnStatus, getTxnStatusRequestBean, errorMessage } = vpa_data.payload.data
                if(errorMessage){
                    if(!vpa_data.payload.data.redirectUrl)
                        this.setState({loader: false, canDisplayUPI: false})
                }else if(getTxnStatus){
                    let attemptCount = 0
                    let timeout = FPConfig.timeout.getTxnStatus/10
                    this.setState({isCalledTxnStatus: true})
                    this.getStatusInterval = setInterval(async () => {
                        try{
                            attemptCount += 1;
                            getTxnStatusRequestBean = {...getTxnStatusRequestBean , inquiryNo:attemptCount};
                            const res = await callGetTxnStatus(getTxnStatusRequestBean);
                            const { transactionStatus, redirectToRetryPayPage } = res.payload
                            this.setState({txnStatus: res.payload})
                            if(transactionStatus==="SUCCESS"){
                                clearInterval(this.getStatusInterval)
                               // document.UPI_UPIForm.submit()
                                this.setState({redirectToRetryPayPage, loader: true , upiScanComplete:true,upiScanSuccess:true});
                            }else if(transactionStatus==="FAILED"){
                                clearInterval(this.getStatusInterval)
                                // document.UPI_UPIForm.submit()
                                this.setState({redirectToRetryPayPage, loader: true , upiScanComplete:true,upiScanSuccess:false});
                            }else if(attemptCount>=timeout){
                                clearInterval(this.getStatusInterval)
                                //     if(redirectToRetryPayPage){  // Retry count should be configurable from merchant
                                //         this.setState({redirectToRetryPayPage, loader: false, canDisplayUPI: false})
                                //     } else {
                                //    //     document.UPI_UPIForm.submit()
                                //     }
                                this.setState({redirectToRetryPayPage, loader: false , upiScanComplete:true,upiScanSuccess:false});
                            }
                        }catch(error){
                            if(attemptCount>=timeout){
                                clearInterval(this.getStatusInterval)
                                //     if(redirectToRetryPayPage){  // Retry count should be configurable from merchant
                                //         this.setState({redirectToRetryPayPage, loader: false, canDisplayUPI: false})
                                //     } else {
                                //    //     document.UPI_UPIForm.submit()
                                //     }
                                this.setState({redirectToRetryPayPage:true, 
                                    loader: true , 
                                    upiScanComplete:true,
                                    upiScanSuccess:false,
                                    txnStatus:{transactionStatus:"FAILED"}
                                });
                            }
                        }
    
                    }, 10000);
                }
            })
        }
    }

    render() {
        const { t } = this.props;
        return(
            <>
                <Col xs="12"> 
                    <div className="card-details-panel d-flex justify-content-center">
                        <Form>
            
                        <figure className="text-center mb-4">
                            <img className="img-response upiStepImage" src={TYPE_OF_CARD} alt="card" title="" />
                        </figure>
                        <div className="container-fluid upi_image_row">
                            <div className="row">
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={BHIM_UPI_Image} alt="BHIMUPI" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={GPAY_UPI_Image} alt="GPAY" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={PHONEPAY_UPI_Image} alt="PHONEPAY" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={PAYTM_UPI_Image} alt="PAYTM" title="" />
                            </figure>
                            </div>
                            </div>
                      
                        </div>
                        <p className="error text-center ml-1 mr-1">({t(('upi_note2'))})</p>

                        <p className="textBlue-14 text-center mb-3 mt-3">({t('upi_note1')})</p>
                        <Button disabled={!this.props.termsStatus} className="btn" onClick={() =>this.submitUPI()}>
                            <DisplayPayBtnText cardMetaData={this.state.cardMetaData} transactionDetails={this.props.transactionDetails} t={t} />
                        </Button>

                        <div className="go-back-site text-center">
                            <GoBack t={t}/>
                        </div>
                        </Form>
                    </div>
                </Col>
                
                { this.state.canDisplayUPI && 
                <UPIModal 
                t={this.props.t} 
                changePayment={this.props.changePayment}
                 closeVpaModal={this.closeVpaModal} 
                 OnProcessUPI= {this.state.loader}
                 modalClassName="custom-otp-popup vpa-popup" 
                 submitVPA={this.submitVPA}
                  txnKey={this.props.txnKey} 
                  txnIv={this.props.txnIv} 
                  callVPAResponse={this.props.callVPAResponse} 
                  transactionDetails={this.props.transactionDetails}
                   /> 
                   }
                { this.state.loader &&  <GlobalLoaderModal isUpi={true} transaction={true} getTxnStatus={true} isCalledTxnStatus={this.state.isCalledTxnStatus} /> }
                {/* {this.state.redirectToRetryPayPage && <GlobalErrorModal retryBtn={true} />}
                <RenderForm className='hidden' upiTxnStatus={this.state.txnStatus} formName="UPI" /> */}

                {this.state.upiScanSuccess &&  this.state.upiScanComplete && 
				<RenderForm className='hidden' sessionID = {this.props.SessionToken} nbRespURL={this.state.txnStatus.merchantRedirectUrl} 
                upiTxnStatus={this.state.txnStatus} formName="BHARATQR" />           
				}
				{!this.state.upiScanSuccess &&  this.state.upiScanComplete && 
				<RenderForm className='hidden' sessionID = {this.props.SessionToken} nbRespURL={FPConfig.upi_failiure} 
				upiTxnStatus={this.state.txnStatus} formName="BHARATQR" />
				}
            </> 
        );
    }
}

const mapStateToProps = state => {
    const {termsStatus, transactionDetails, txnKey, txnIv, SessionToken, integrationType, selectedPayment, globalConfig:{ customerDetails }} = state.fdData
    let returnProps = {termsStatus, transactionDetails, txnKey, txnIv,SessionToken,integrationType, selectedPayment, customerDetails }
    return { ...returnProps }
}

export default connect(mapStateToProps, { callVPAResponse })(UPI);